"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ImageCard = _interopRequireDefault(require("./../../block/ImageCard"));
function ImageCard(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "image-card-slide"
  }, /*#__PURE__*/_react.default.createElement(_ImageCard.default, props));
}
var _default = exports.default = ImageCard;